import CreateChallengeSet from '@/src/components/challenges/challengeSets/CreateChallengeSet';
import React from 'react';

export const NewChallengeSetPage: React.FC = () => {
  return <CreateChallengeSet />;
};
